import academicYearServices from '@/services/academicyear';
import appointmentServices from '@/services/api/appointment.api';
import companyServices from '@/services/api/company.api';
import locationServices from '@/services/api/location.api';

export default {
  initFilters(context) {
    context.commit('setFilterValue', { property: 'academicYear', data: null });

    appointmentServices
      .getAppointmentSearchInitialFilterValues()
      .then(({ data }) => {
        context.commit('setFilters', data.filters);

        context.commit('setAcademicYears', data.collections.academicYears);
        context.commit('setMonths', data.collections.months);
        context.commit('setServices', data.collections.services);
        context.commit('setDisciplines', data.collections.disciplines);
        context.commit('setCenters', data.collections.centers);
        context.commit('setDistricts', data.collections.districts);
        context.commit('setMunicipalities', data.collections.municipalities);
        context.commit('setSchools', data.collections.schools);
        context.commit('setProviders', data.collections.providers);
        context.commit('setStatus', data.collections.status);
      });
  },
  loadResults(context, filterProperties) {
    appointmentServices
      .getAppointmentSearchData(filterProperties)
      .then(({ data }) => {
        context.commit('setResults', data.data);

        context.commit('setPagination', {
          count: data.count,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          totalPages: data.pageCount,
          totalRecords: data.totalItemCount,
          pageSize: 10,
        });
      });
  },
  onAcademicYearChanged(context) {
    context.commit('resetByAcademicYear');

    if (context.state.filters.academicYear != null) {
      academicYearServices
        .getAvailableMonths(context.state.filters.academicYear.id)
        .then(({ data }) => {
          context.commit('setMonths', data);

          if (context.state.filters.provider != null) {
            context.dispatch('loadSpecialists');
          }
        })
        .catch();
    }

    context.dispatch('loadCenters');
    context.dispatch('loadServices');
    context.dispatch('loadProviders');
  },
  loadServices(context) {
    appointmentServices
      .getAppointmentServices()
      .then(({ data }) => {
        context.commit('setServices', data);
      })
      .catch();
  },
  loadDisciplines(context) {
    const service = context.state.filters.service;
    let serviceTypeId = service && service.id ? service.id : 0;

    if (serviceTypeId > 0) {
      appointmentServices
        .getValidAppointmentDisciplines(serviceTypeId)
        .then(({ data }) => {
          context.commit('setDisciplines', data);
        })
        .catch();
    } else {
      context.commit('setDisciplines', null);
      context.state.filters.discipline = null;
    }
  },
  loadCenters(context) {
    if (context.state.filters.academicYear != null) {
      locationServices
        .getCenters({ academicYearId: context.state.filters.academicYear.id })
        .then(({ data }) => {
          context.commit('setCenters', data);

          if (data.length == 1 && data[0].selected) {
            context.dispatch('onCenterChanged');
          }
        })
        .catch();
    }
  },
  onServiceChanged(context) {
    context.dispatch('loadDisciplines');

    if (context.state.filters.service == null)
      context.commit('setDisciplines', null);
  },
  onCenterChanged(context) {
    context.commit('resetByCenter');

    if (
      context.state.filters.academicYear != null &&
      context.state.filters.center != null
    ) {
      locationServices
        .getDistricts({
          academicYearId: context.state.filters.academicYear.id,
          centerId: context.state.filters.center.id,
        })
        .then(({ data }) => {
          context.commit('setDistricts', data);

          if (data.length == 1 && data[0].selected) {
            context.dispatch('onDistrictChanged');
          }
        })
        .catch();
    } else {
      context.commit('setDistricts', null);
    }
  },
  onDistrictChanged(context) {
    context.commit('resetByDistrict');

    if (
      context.state.filters.academicYear != null &&
      context.state.filters.district != null
    ) {
      locationServices
        .getMunicipalities({
          academicYearId: context.state.filters.academicYear.id,
          districtId: context.state.filters.district.id,
        })
        .then(({ data }) => {
          context.commit('setMunicipalities', data);

          if (data.length == 1 && data[0].selected) {
            context.dispatch('onMunicipalityChanged');
          }
        })
        .catch();
    } else {
      context.commit('setMunicipalities', null);
    }
  },
  onMunicipalityChanged(context) {
    context.commit('resetByMunicipality');

    if (
      context.state.filters.academicYear != null &&
      context.state.filters.municipality != null
    ) {
      locationServices
        .getSchools({
          academicYearId: context.state.filters.academicYear.id,
          municipalityId: context.state.filters.municipality.id,
        })
        .then(({ data }) => {
          context.commit('setSchools', data);
        })
        .catch();
    } else {
      context.commit('setSchools', null);
    }
  },
  loadStatus(context) {
    appointmentServices
      .getAppointmentStatus()
      .then(({ data }) => {
        context.commit('setStatus', data);
      })
      .catch();
  },
  loadProviders(context) {
    companyServices
      .getCompanies()
      .then(({ data }) => {
        context.commit('setProviders', data);
      })
      .catch();
  },
  onProviderChanged(context) {
    context.commit('resetByProvider');

    if (
      context.state.filters.provider != null &&
      context.state.filters.academicYear != null
    ) {
      context.dispatch('loadSpecialists');
    } else {
      context.commit('setSpecialits', null);
    }
  },
  loadSpecialists(context) {
    if (context.state.filters.academicYear != null) {
      companyServices
        .getSpecialists({
          companyId: context.state.filters.provider.id,
          academicYearId: context.state.filters.academicYear.id,
        })
        .then(({ data }) => {
          context.commit('setSpecialits', data);
        })
        .catch();
    }
  },
};
